import React from "react";
import { Input, Form, InputNumber } from "antd"; // On n'a plus besoin de Row et Col

const FormFields = () => {
  return (
    <>
      {/* Champ 1 */}
      <Form.Item
        name="productCode"
        label="Code Produit"
      >
        <Input placeholder="Ex: dh12345" />
      </Form.Item>

      {/* Champ 2 */}
      <Form.Item
        name="family"
        label="Famille"
      >
        <Input placeholder="Ex: dh" />
      </Form.Item>

      {/* Champ 3 */}
      <Form.Item
        name="name"
        label="Nom de Produit"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom du produit",
          },
        ]}
      >
        <Input placeholder="Nom de produit" />
      </Form.Item>

      {/* Champ 4 */}
      <Form.Item
        name="price"
        label="Prix"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le prix",
          },
          {
            type: 'number',
            message: "Le prix doit être un nombre valide",
          },
        ]}
      >
        <InputNumber
          placeholder="Prix"
          style={{ width: '100%' }}
          min={0}
          step={0.01}
        />
      </Form.Item>

      {/* Champ 5 */}
      <Form.Item
        name="barCode"
        label="Code Barre"
      >
        <Input placeholder="Code Barre" />
      </Form.Item>
    </>
  );
};

export default FormFields;